export { Mark } from './mark';
export type { MarkProps } from './mark';
export type { MarkStylesParams } from './mark.styles';
